var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"return"},[_c('router-link',{attrs:{"to":{path:'/meeting/details',query:{meeting_id:_vm.meeting_id}}}},[_c('van-icon',{attrs:{"name":"home-o"}}),_vm._v(" "),_c('span',[_vm._v("首页")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6d7e5f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Meeting/Return.vue
// module id = null
// module chunks = 